import ButtonCommon from './ButtonCommon';

export default ButtonCommon;
